import React from "react";

function ProjectIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 22 16.5">
      <path
        d="M19.938,7.25h-8.25L8.938,4.5H2.063A2.062,2.062,0,0,0,0,6.563V18.938A2.062,2.062,0,0,0,2.063,21H19.938A2.062,2.062,0,0,0,22,18.938V9.313A2.062,2.062,0,0,0,19.938,7.25Z"
        transform="translate(0 -4.5)"
      />
    </svg>
  );
}

export { ProjectIcon };
